import { render, staticRenderFns } from "./AtomButton.vue?vue&type=template&id=d4737cc8&"
import script from "./AtomButton.vue?vue&type=script&lang=js&"
export * from "./AtomButton.vue?vue&type=script&lang=js&"
import style0 from "./AtomButton.vue?vue&type=style&index=0&id=d4737cc8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AtomsCommonAtomIcon: require('/app/components/atoms/common/AtomIcon.vue').default})
